import { render } from "./FileBadge.vue?vue&type=template&id=919ac44e"
import script from "./FileBadge.vue?vue&type=script&lang=js"
export * from "./FileBadge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__